
import Vue from 'vue';
import ConfirmDialog from '@/components/base/ConfirmDialog.vue';
import _trim from 'lodash/trim';
import { getLastSsoProviderVal, setLastSsoProviderVal } from '@/utils';
import { mapState } from 'vuex';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';

export default Vue.extend({
	name: 'SsoProviderInputDialog',
	props: {
		requireSwitchToSso: { type: Boolean, default: false }, // Used in the change-login-method/provider use case (not the login page)
		value: { type: Boolean, default: false },
	},
	data () {
		return {
			localSsoProviderVal: null,
		};
	},
	created () {
		this.localSsoProviderVal = _trim(getLastSsoProviderVal()).replace(/\s+/g, '').toLowerCase() || null;
	},
	computed: {
		...mapState([
			'team',
			'runnitState',
		]),
		shouldUseCurrCompanySsoIdentifier () {
			return !!(this.team?.company?.sso?.identifier && this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM);
		},
		computedSsoProviderVal () {
			return this.shouldUseCurrCompanySsoIdentifier ? this.team.company.sso.identifier : this.localSsoProviderVal;
		},
		computedSsoProviderComponents () {
			const suffix: string = _trim(this.computedSsoProviderVal)
				.replace(/\s+/g, '')
				.toLowerCase()
				.replace(/^saml\./, '');
			return {
				suffix: suffix || null,
				full: suffix ? `saml.${suffix}` : null,
			};
		},
	},
	methods: {
		onConfirm (closeCallback: Function) {
			if (!this.computedSsoProviderComponents.full) return;
			setLastSsoProviderVal(this.computedSsoProviderComponents.suffix);
			this.$emit('on-submit', closeCallback, this.computedSsoProviderComponents.full);
		},
	},
	components: {
		ConfirmDialog,
	},
});
